import React from 'react'

import type { IconProps } from '../iconProps'
import { s } from './icon.style'

export const EditIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 16.6671V20H7.33287L17.1626 10.1703L13.8297 6.83738L4 16.6671ZM19.74 7.59283C20.0867 7.24622 20.0867 6.68629 19.74 6.33968L17.6603 4.25996C17.3137 3.91335 16.7538 3.91335 16.4072 4.25996L14.7807 5.8864L18.1136 9.21927L19.74 7.59283V7.59283Z"
          fill="black"
          fill-opacity="0.87"
        />
      </svg>
    )
  },
)
